export interface Milestone {
  year: string;
  title: string;
  description: string;
}

export interface Honor {
  id: string;
  title: string;
  issuer: string;
  date: string;
  description: string;
}

export interface TeamMember {
  id: string;
  name: string;
  title: string;
  description: string;
  image: string;
}

export const milestones: Milestone[] = [
  { year: '2025.03', title: '尊龙集团成立', description: '在安徽合肥正式注册成立，定位为一体化DRAM存储器制造企业，初始注册资本50亿元人民币。' },
  { year: '2025.06', title: '完成Pre-A轮融资', description: '获得国家集成电路产业投资基金、合肥产投等战略投资方联合投资，融资总额达80亿元人民币。' },
  { year: '2025.09', title: '合肥研发中心一期启用', description: '建筑面积2.5万平方米的研发中心正式投入使用，首批300名研发工程师入驻。' },
  { year: '2025.12', title: 'DDR5芯片流片成功', description: '基于1β制程的DDR5 5600MT/s芯片首次流片成功，功能验证全部通过，性能指标达到设计预期。' },
  { year: '2026.01', title: 'LPDDR5X荣获CES创新奖', description: '在美国CES 2026展会上，LPDDR5X产品荣获"年度存储技术创新奖"，获得国际行业认可。' },
  { year: '2026.03', title: '完成A轮融资', description: '完成A轮融资100亿元，引入多家顶级产业资本与财务投资机构，用于推进DDR5量产产能建设。' },
  { year: '2026.06', title: '研发中心二期启用', description: '研发中心二期正式投入使用，研发团队突破2000人，硕博占比超65%。' },
  { year: '2026.07', title: 'DDR5正式量产', description: 'DDR5 5600MT/s芯片正式进入大规模量产，首批良率突破92%，获得多家头部客户认证。' },
];

export const honors: Honor[] = [
  {
    id: '1',
    title: 'CES 2026 年度存储技术创新奖',
    issuer: 'CES国际消费电子展组委会',
    date: '2026年1月',
    description: 'LPDDR5X 8533Mbps低功耗存储芯片凭借卓越能效比和创新架构设计，荣获国际权威媒体与评审团一致认可。',
  },
  {
    id: '2',
    title: '国家高新技术企业',
    issuer: '国家科技部',
    date: '2025年10月',
    description: '凭借在DRAM芯片设计领域的核心技术积累和创新能力，获评国家高新技术企业资质认定。',
  },
  {
    id: '3',
    title: '安徽省半导体产业领军企业',
    issuer: '安徽省工业和信息化厅',
    date: '2025年12月',
    description: '作为安徽省存储器产业的龙头企业，获得省级产业领军企业称号，享受重点产业扶持政策。',
  },
  {
    id: '4',
    title: '中国集成电路创新联盟理事单位',
    issuer: '中国集成电路创新联盟',
    date: '2026年3月',
    description: '正式成为中国集成电路创新联盟理事单位，深度参与国家存储器产业标准制定与技术创新协作。',
  },
  {
    id: '5',
    title: 'ISO 9001 / ISO 14001 双认证',
    issuer: '国际标准化组织（ISO）',
    date: '2026年5月',
    description: '通过ISO 9001质量管理体系与ISO 14001环境管理体系双重认证，达到国际标准化管理水平。',
  },
  {
    id: '6',
    title: '2026年度中国半导体最具成长力企业',
    issuer: '中国半导体行业协会',
    date: '2026年6月',
    description: '因在DRAM领域的高速成长与技术突破，被评为2026年度中国半导体最具成长力企业TOP10。',
  },
];

export const teamMembers: TeamMember[] = [
  {
    id: '1',
    name: '陈志远',
    title: '创始人兼首席执行官（CEO）',
    description: '前国际知名存储大厂高级副总裁，拥有超过25年半导体行业经验。清华大学电子工程博士，斯坦福大学MBA。曾主导多款业界领先DRAM产品的研发与量产。',
    image: 'https://readdy.ai/api/search-image?query=Professional%20Asian%20male%20executive%20portrait%20in%20business%20suit%2C%20clean%20white%20studio%20background%2C%20confident%20expression%2C%20corporate%20headshot%20photography%2C%20soft%20professional%20lighting&width=400&height=400&seq=team-ceo-01&orientation=squarish',
  },
  {
    id: '2',
    name: '张明华',
    title: '首席技术官（CTO）',
    description: '前三星半导体DRAM设计部门首席工程师，中科院微电子所博士。拥有超过50项DRAM相关国际专利，在1β/1γ先进制程领域具有深厚技术积累。',
    image: 'https://readdy.ai/api/search-image?query=Professional%20Asian%20male%20engineer%20portrait%20in%20business%20casual%2C%20clean%20white%20studio%20background%2C%20thoughtful%20expression%2C%20corporate%20headshot%20photography%2C%20soft%20professional%20lighting&width=400&height=400&seq=team-cto-02&orientation=squarish',
  },
  {
    id: '3',
    name: '王磊',
    title: '市场战略副总裁',
    description: '前美光科技亚太区市场总监，拥有15年半导体市场与战略规划经验。北京大学光华管理学院MBA，对全球存储器市场格局有深刻的洞察与预判能力。',
    image: 'https://readdy.ai/api/search-image?query=Professional%20Asian%20male%20business%20leader%20portrait%2C%20clean%20white%20studio%20background%2C%20confident%20smile%2C%20corporate%20headshot%20photography%2C%20soft%20professional%20lighting&width=400&height=400&seq=team-vp-03&orientation=squarish',
  },
];

export const companyInfo = {
  name: '尊龙集团',
  fullName: '尊龙半导体科技有限公司',
  founded: '2025年',
  headquarters: '安徽省合肥市高新技术产业开发区创新大道2800号',
  phone: '+86 551 6666 8888',
  email: 'info@zunlonggroup.com',
  website: 'www.zunlonggroup.com',
  description: '尊龙集团是一家一体化存储器制造公司，专注于动态随机存取存储芯片（DRAM）的设计、研发、生产和销售。集团总部位于安徽合肥，在上海、深圳、硅谷和新竹设有研发中心，全球员工总数超过3000人。尊龙集团致力于成为中国领先、全球一流的存储器解决方案提供商。',
  values: [
    { title: '创新驱动', description: '以技术创新为核心驱动力，持续投入前沿存储技术研发，保持技术领先优势。', icon: 'ri-rocket-line' },
    { title: '品质至上', description: '坚守最高质量标准，从芯片设计到封装测试每个环节精益求精，确保产品可靠性。', icon: 'ri-shield-check-line' },
    { title: '客户为先', description: '深入理解客户需求，提供定制化存储解决方案与全生命周期技术支持服务。', icon: 'ri-user-heart-line' },
    { title: '合作共赢', description: '与产业链上下游伙伴紧密协作，共同构建开放、健康、可持续的存储产业生态。', icon: 'ri-group-line' },
  ],
};